import React from 'react';
import CTA from 'components/cta';
import { styled } from 'themes';
import { device } from 'themes/media-queries';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'navigation/route-map';

const CTASection = () => {
  const [t] = useTranslation();
  return (
    <Section>
      <CTA
        title={t('cta-section.heading')}
        buttonLabel={t('cta-section.buttonLabel')}
        buttonUrl={ROUTES.DOWNLOAD}
      />
    </Section>
  );
};

const Section = styled.section`
  grid-column: semi-full-start / semi-full-end;

  @media ${device.tablet} {
    grid-column: full-start / full-end;
  }
`;

export default CTASection;
